import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-ev-loader',
  templateUrl: './ev-loader.component.html',
  styleUrls: ['./ev-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EvLoaderComponent {
  @Input() label: string = 'Loading';
}
